import React from 'react';
import AboutPageComponent from '../components/AboutPage/AboutPage';

/**
 * AboutPage - About page wrapper
 */
export default function AboutPage() {
  return <AboutPageComponent />;
}
